// extracted by mini-css-extract-plugin
export default {"wrapper":"Delivery_wrapper__VaVbI","header":"Delivery_header__LxpxY","goBack":"Delivery_goBack__l3WgZ","container":"Delivery_container__j1MxR"};